export default {
  // ========== Competence specific texts ==========
  writingLabel: 'Writing',
  associateCompetence: 'Associate {entity}',
  associateDescriptor: 'Associate {entity}',
  insertMode: 'Insert',
  createMode: 'Create',
  insertOrCreateTooltip: 'Enter sentence directly or use "creation" mode',
  clearSelection: '--- Clear selection ---',
  subOrderLabel: 'Sub order',
  orderTooltip: 'This profile already has a {entity} in this order.',
  relationshipCreated: 'Relationship between {entity1} and {entity2} created.',
  relationshipUpdated: 'Relationship between {entity1} and {entity2} updated.',
  deletedFromProfile: '{entity} deleted from {profile}.',
  noRaBaseMessage: 'This {entity} does not have any {raBase}.',
  deleteAssociationConfirm: 'Are you sure you want to delete the association of this instance of "{entity}"?',
  selectToAssociate: 'Select the {entity} to associate.',
  associate: 'Associate',
  // Competence Sentence form fields
  action: 'Action',
  object: 'Object',
  condition: 'Condition',
  context: 'Context',
  verb: 'Verb',
  content: 'Content',
  // Help information
  informationTitle: 'Information',
  whatDoes: 'What does?',
  whatWillKnow: 'What will they know how to do?',
  actionToPerform: 'The action to',
  perform: 'perform',
  expressedInIndicative: 'It is expressed in',
  indicative: 'indicative',
  indicativeExamples: '(designs, communicates).',
  reflectsAction: 'Reflects an',
  assessableAction: 'action feasible to assess',
  observableAction: 'and observe in present tense.',
  aboutWhat: 'About What',
  aboutWhatDetail: 'performs the action (object).',
  whatWillAsk: 'What will I ask them to evaluate, handle, analyze, report?',
  forWhat: 'For What?',
  attitudes: 'Attitudes (Transversal Competencies)',
  attitudesDetail: 'Considered in relation to the object/content and the action to be performed.',
  inWhatContext: 'In What Context',
  contextDetail: 'What means, scenarios, situations, regulatory contexts?',
  contextRelation: 'Considered in relation to the condition, object/content and the action to be performed.',
  // Taxonomy and verbs
  showTaxonomy: 'Show {entity}',
  hideTaxonomy: 'Hide {entity}',
  selectTaxonomy: '--Select Taxonomy--',
  customizeVerb: 'Customize',
  verbWithoutCognitiveLevel: 'This verb will be saved without cognitive level.',
  noVerbsMatch: 'There are no {entity} matching your search.',
  cognitiveLevel: 'Cognitive level',
  // Validation messages
  mustSelectVerb: 'You must select a verb.',
  contentCannotBeEmpty: 'Content cannot be empty.',
  conditionCannotBeEmpty: 'Condition cannot be empty.',
  contextCannotBeEmpty: 'Context cannot be empty.',
  // Egress Profile and Competencies
  associateToProfile: 'Associate {entity1} to {entity2}',
  linkToAll: 'Link to all ({count})',
  linkToAllTooltip: 'Links this {competence} to the {profiles} in the table that do not have it yet. If there is a search, only to the matching ones. Closed {profiles} are not included.',
  linkToAllSaveFirst: 'Save the {competence} first to link it to all {profiles}.',
  linkToAllConfirmTitle: 'Link the {competence} to {count} {profiles}?',
  linkToAllConfirmText: 'Each link goes at the end of the order of its {profile}.',
  linkToAllConfirmButton: 'Link',
  linkedToProfiles: '{competence} linked to {count} {profiles}.',
  definePositionInProfile: 'Define position of {entity1} with respect to {entity2}.',
  notApplicable: '-- Not applicable --',
  // Competence Descriptors
  programs: 'Programs',
  deleteDescriptorContentConfirm: 'Are you sure you want to delete the descriptive title content?',
  deleteDescriptorTitleConfirm: 'Are you sure you want to delete the descriptive title?',
  deleteDescriptorWarning: 'This action cannot be undone and the referenced objects below will be deleted.',
  title: 'Title',
  // CapacityForm
  isInstitutional: 'It is an institutional {entity}',
  mustAddFaculty: 'You must add the {faculty} of the {profile}.',
}
